import 'react-datepicker/dist/react-datepicker.css';

import { FieldTitle, useInput } from 'react-admin';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import React, { useRef, useState } from 'react';

import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import DatePicker from 'react-datepicker';
import { cs } from 'date-fns/locale';

interface DateInputProps {
  source: string;
  label?: string;
  defaultValue?: string;
  readOnly?: boolean;
  validate?: any;
  fullWidth?: boolean;
  size?: 'small' | 'medium';
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onChange?: (event: React.SyntheticEvent<{ value: string }>) => void;
}

const DateInput = ({ source,
  label,
  defaultValue,
  readOnly,
  validate,
  fullWidth,
  size = 'small',
  onFocus,
  onChange, }: DateInputProps) => {
  const {
    field: { value, onChange: raOnChange, ref },
    fieldState: { error },
    isRequired,
  } = useInput({ source, defaultValue, validate });

  const [isOpen, setIsOpen] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);

  return (
<>
      <DatePicker
        selected={value ? new Date(value) : null}
        onChange={(date: Date | null) => {
          const iso = date ? date.toISOString() : null;
          raOnChange(iso);
          if (onChange) {
            onChange({
              target: { value: iso },
            } as unknown as React.SyntheticEvent<{ value: string | null }>);
          }
          setIsOpen(false);
        }}
        onClickOutside={() => setIsOpen(false)}
        open={isOpen}
        onSelect={() => setIsOpen(false)}
        dateFormat="dd.MM.yyyy"
        locale={cs}
        customInput={
          <TextField
            label={<FieldTitle label={label} source={source} isRequired={isRequired} />}
            variant="filled"
            size={size}
            value={value ? new Date(value).toLocaleDateString('cs-CZ') : ''}
            onChange={(e) => {
              const parsed = new Date(e.target.value);
              const iso = isNaN(parsed.getTime()) ? null : parsed.toISOString();
              raOnChange(iso);
              if (onChange) {
                onChange({
                  target: { value: iso },
                } as unknown as React.SyntheticEvent<{ value: string | null }>);
              }
            }}
            onFocus={onFocus}
            fullWidth={fullWidth}
            inputRef={inputRef}
            error={!!error}
            helperText={error?.message}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => {
                      setIsOpen(true);
                    }}
                    disabled={readOnly}
                    size="small"
                  >
                    <CalendarTodayIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ),
              readOnly: readOnly ?? false,
            }}
          />
        }
        disabled={readOnly}
      />
    </>
  );
};

export default DateInput;